import React from "react";

const DEVANAGARI = [
  "ॐ सर्वेषां स्वस्तिर्भवतु ।",
  "सर्वेषां शान्तिर्भवतु ।",
  "सर्वेषां पूर्णं भवतु ।",
  "सर्वेषां मङ्गलं भवतु ।",
  "ॐ शान्तिः शान्तिः शान्तिः ॥",
];
const TRANSLIT = [
  "Om Sarveṣām Svastir Bhavatu |",
  "Sarveṣām Śāntir Bhavatu |",
  "Sarveṣām Pūrṇam Bhavatu |",
  "Sarveṣām Maṅgalam Bhavatu |",
  "Om Śāntiḥ Śāntiḥ Śāntiḥ ॥",
];

// Sarveśām Svastir Bhavatu — a universal Vedic peace mantra: may all be well, at peace,
// fulfilled and blessed. It anchors My Kind's promise of one human family.
export function ShantiMantra({ compact = false }) {
  return (
    <div data-testid="shanti-mantra" className={compact ? "text-center" : "rud-card rounded-2xl p-6 sm:p-8 text-center"}>
      <div className="text-[10px] uppercase tracking-[0.22em] text-brand mb-3">Sarveṣām Svastir Bhavatu · Śānti Mantra</div>
      <div className="font-serif text-lg sm:text-xl leading-relaxed text-[var(--rud-text)]">
        {DEVANAGARI.map((l, i) => <div key={i}>{l}</div>)}
      </div>
      <div className="text-sec text-xs sm:text-sm italic leading-relaxed mt-3">
        {TRANSLIT.map((l, i) => <div key={i}>{l}</div>)}
      </div>
      <p className="text-sec text-xs mt-4 max-w-md mx-auto">May all be well. May all be at peace. May all be whole. May all be blessed. Om, peace, peace, peace.</p>
    </div>
  );
}

export default ShantiMantra;
